import styled from 'styled-components';

export const SectionDescription = styled.p`
  color: ${({ theme }) => theme.colors?.text?.secondary || '#666'};
  margin-bottom: 1rem;
`;

export const Toolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: flex-end;
  margin-bottom: 1rem;
`;

export const SearchInput = styled.input`
  flex: 1;
  min-width: 200px;
  padding: 0.5rem 0.75rem;
  border: 1px solid ${({ theme }) => theme.colors?.border?.light || '#e5e7eb'};
  border-radius: 8px;
  font-size: 0.9375rem;
`;

export const ErrorRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;
